import './App.css';
import Header from './components/Header/Header';
import Players from './components/Players/Players';

function App() {
  return (
    <div className="App">
      <Header />
      <Players />
    </div>
  );
}

export default App;
